module.exports = __webpack_public_path__ + "static/media/competitorActive.6a859cc0.svg";